import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X, Radio } from "lucide-react";

const navLinks = [
  { label: "Home", path: "/" },
  { label: "About", path: "/about" },
  { label: "Books", path: "/books" },
  { label: "Papers", path: "/papers" },
  { label: "Essays", path: "/essays" },
  { label: "Captain's Log", path: "/blog" },
  { label: "Radio", path: "/ad0k" },
  { label: "Music", path: "/music" },
  { label: "The Dispatch", path: "/newsletter" },
  { label: "Press", path: "/press" },
  { label: "Contact", path: "/contact" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => setOpen(false), [location]);

  return (
    <nav
      data-testid="navbar"
      className="fixed top-0 left-0 right-0 z-50 bg-[#F5F0E8]/95 backdrop-blur-xl border-b border-[#0A1628]/10 shadow-sm"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <Link to="/" data-testid="navbar-logo" className="flex items-center gap-2 group">
            <div className="w-8 h-8 bg-[#0A1628] flex items-center justify-center">
              <Radio size={16} className="text-[#C5A059]" />
            </div>
            <span className="font-serif text-[#0A1628] font-bold tracking-wide text-sm uppercase">
              Donald Inbody
            </span>
          </Link>

          {/* Desktop Links */}
          <div className="hidden md:flex items-center gap-8">
            {navLinks.map(({ label, path }) => (
              <Link
                key={path}
                to={path}
                data-testid={`nav-link-${label.toLowerCase()}`}
                className={`text-sm font-medium transition-colors duration-200 relative group ${
                  location.pathname === path
                    ? "text-[#C5A059]"
                    : "text-[#2D3142] hover:text-[#0A1628]"
                }`}
              >
                {label}
                <span className={`absolute -bottom-1 left-0 h-px bg-[#C5A059] transition-all duration-300 ${
                  location.pathname === path ? "w-full" : "w-0 group-hover:w-full"
                }`} />
              </Link>
            ))}
          </div>

          {/* Mobile Toggle */}
          <button
            data-testid="navbar-mobile-toggle"
            onClick={() => setOpen(!open)}
            className="md:hidden text-[#0A1628] p-2"
          >
            {open ? <X size={20} /> : <Menu size={20} />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {open && (
        <div className="md:hidden bg-[#F5F0E8]/95 backdrop-blur-xl border-t border-[#0A1628]/10">
          <div className="px-6 py-4 flex flex-col gap-4">
            {navLinks.map(({ label, path }) => (
              <Link
                key={path}
                to={path}
                data-testid={`mobile-nav-${label.toLowerCase()}`}
                className={`text-sm font-medium py-2 border-b border-[#0A1628]/8 ${
                  location.pathname === path ? "text-[#C5A059]" : "text-[#2D3142]"
                }`}
              >
                {label}
              </Link>
            ))}
          </div>
        </div>
      )}
    </nav>
  );
}
